import { type BaseFilterValues, useReportFilters } from './useReportFilters'

export type TrackingFilterValues = BaseFilterValues

export const useTrackingFilters = () => {
  return useReportFilters<TrackingFilterValues>({
    initFromParams: () => ({}),
  })
}
